import defaultRouteSettings from "./default";
import RegistrationForm from '../../custom/saylani/components/Registration/RegistrationForm.vue';
import EnrollmentForm from '../../custom/saylani/components/Enrollment/EnrollmentForm.vue';

const routes = defaultRouteSettings.routes;

routes.forEach((route) => {
    if (route.path === '/register') {
        route.component = RegistrationForm;
    }

    if (route.path === '/account' && route.children?.length > 0) {
        route.children.forEach((child) => {
            if (child.path === 'register') {
                child.component = RegistrationForm;
            }
        });
    }
});

routes.push({
    path: "/sbil-enrollment-form",
    name: "EnrollmentForm",
    component: EnrollmentForm,
    meta: {
        title: "Enroll Courses",
        requiresAuth: true,  
    },
});

export default {
    routes,
    beforeEach: defaultRouteSettings.beforeEach, 
};
